import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { CountryConfig } from "../types";

interface GenericAmountProps {
  config: CountryConfig;
  handleNext: () => void;
  handlePrevious: () => void;
}

const Amount: React.FC<GenericAmountProps> = ({ config, handleNext, handlePrevious }) => {
  const countryKey = (config.dataSliceKey || config.code).toLowerCase();
  const asiaPayoutData = useAppSelector((state) => (state.formData as any)?.asiaPayoutData);
  const getSavedData = asiaPayoutData?.[countryKey] || {};

  const paymentMethod = getSavedData?.paymentMethod || "bank_account";

  const AmountComponent =
    (config.formRegistry.amount?.[paymentMethod] as any) ||
    (config.formRegistry.amount?.default as any);

  if (!AmountComponent) return null;

  return (
    <AmountComponent
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      config={config}
    />
  );
};

export default Amount;
